














































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Input from '@/components/Input.vue';
import { namespace } from 'vuex-class';
import { BottomWrapper } from '../../BottomWrapper.vue';
import { TransStatement } from '@/common/api/model';
import { TransactionType } from '@/common/config';
import { formatMoney } from '@/common/utils';
import { TransactionInputEvent } from '@/common/types';
import FaCheckSquare from '@/components/icons/FaCheckSquare.vue';
import FaRegSquare from '@/components/icons/FaRegSquare.vue';

const userModule = namespace('user');
const chatModule = namespace('chat');

@Component({
  components: {
    Input,
    BottomWrapper,
    FaCheckSquare,
    FaRegSquare,
  },
  filters: {
    formatDate (value: any) {
      const options = { hour12: false, month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' } as const;
      const date = new Date(value);
      return date.toLocaleString(undefined, options);
    },
    formatMoney (value: number) {
      return formatMoney(value);
    },
  },
})
export default class GuestForm extends Vue {
  transactionStatusMap = {
    10: 'Processing',
    20: 'Succeed',
    30: 'Failed',
    90: 'Unknown',
  }
  prepositionMap = {
    1: 'from',
    2: 'to',
    3: 'of',
  }

  get buttons () {
    return [{
      name: this.$t('page.guest.button.proceed'),
      id: '',
      isActive: true,
    }];
  }
  @userModule.Getter('currency') currency!: string;
  @Prop({ default: () => ([]) }) readonly transactions!: TransStatement[];
  @Prop({ default: '' }) readonly transactionType!: TransactionType
  @chatModule.Mutation('updateExtraTransactionInfo') updateExtraTransactionInfo!: Function;

  selectedTransIssue: TransStatement[] = [];
  expandedTrans: string[] = [];
  noneSelected: boolean = false;

  get actionType () {
    return TransactionType[this.transactionType];
  }
  get preposition () {
    return this.prepositionMap[this.transactionType];
  }
  get isNoRecord () {
    return this.transactions.length === 0;
  }
  get canProceed () {
    return this.selectedTransIssue.length || this.noneSelected || this.isNoRecord;
  }
  get operator () {
    return this.transactionType === 1 ? '+' : '-';
  }

  selectIssueTransactions (statement: TransStatement) {
    const index = this.selectedTransIssue.findIndex((trans) => trans.tradeId === statement.tradeId);
    const exist = index !== -1;
    if (exist) {
      this.selectedTransIssue.splice(index, 1);
    } else {
      this.noneSelected = false;
      this.selectedTransIssue.push({ ...statement });
    }
  }
  expandTrans (tradeId: string) {
    const index = this.expandedTrans.indexOf(tradeId);
    const exist = index !== -1;
    if (exist) {
      this.expandedTrans.splice(index, 1);
    } else {
      this.expandedTrans.push(tradeId);
    }
  }
  selectNone () {
    if (this.noneSelected) {
      this.noneSelected = false;
    } else {
      this.selectedTransIssue = [];
      this.noneSelected = true;
    }
  }
  proceed () {
    const issueMsg = this.selectedTransIssue.reduce((acc: string[], cur) => {
      const authority = cur.counterAuthority ? cur.counterAuthority : cur.counterFull;
      const msg = `${this.actionType} ${authority ? this.preposition : ''} ${authority || ''} ${formatMoney(cur.amount)} ${this.currency} (transaction id: ${cur.tradeId})`;
      return [...acc, msg];
    }, []);

    const data = [{
      extraFieldKey: 'Transaction',
      extraFieldValue: this.selectedTransIssue.reduce((acc, cur) => {
        const msg = `${this.actionType} ${this.preposition} ${cur.counterAuthority ? cur.counterAuthority : cur.counterFull} ${formatMoney(cur.amount)} ${this.currency}`;
        return acc ? `${acc} / ${msg}` : `${msg}`;
      }, ''),
    }, {
      extraFieldKey: 'Transaction ID',
      extraFieldValue: this.selectedTransIssue.reduce((acc, cur) => acc ? `${acc} / ${cur.tradeId}` : `${cur.tradeId}`, ''),
    }];
    this.updateExtraTransactionInfo(data);

    if (this.canProceed) {
      const $event: TransactionInputEvent = { type: this.transactionType, issues: issueMsg, none: this.noneSelected, meta: data, empty: this.isNoRecord };
      this.$emit('transaction:input', $event);

      // this.$emit('transaction', {
      //   msgs: [{
      //     type: 'chat.msg',
      //     display_name: 'Chat Agent',
      //     nick: 'agent:rule',
      //     timestamp: +new Date(),
      //     member_type: 'visitor',
      //     msg: this.noneSelected ? `I have an issue with a different ${this.actionType}` : 'I have issue with', // TODO
      //     issueMsg,
      //     step: stepEnum['RuleEngine'],
      //     copy: true,
      //   }, {
      //     type: 'chat.msg',
      //     display_name: 'Chat Agent',
      //     nick: 'agent:rule',
      //     timestamp: +new Date() + 1,
      //     member_type: 'agent',
      //     msg: 'Please mention your issue in detail',
      //   }],
      //   noRecord: this.isNoRecord,
      // });
    }
  }
}
